import { InjectionToken } from '@angular/core';

export const GRAPH_BASKET_KEY = new InjectionToken<string>(
  'Key to be used by the graph basket service'
);
